module.exports = __webpack_public_path__ + "img/toggle_up.a5233e64.png";